/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Checkout_Payment_ErrorInputs */

const vi_pos_checkout_payment_error = /** @type {(inputs: Pos_Checkout_Payment_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán thất bại`)
};

/**

* @param {Pos_Checkout_Payment_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_checkout_payment_error = /** @type {((inputs?: Pos_Checkout_Payment_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Checkout_Payment_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_checkout_payment_error(inputs)
});